<div class="mb-[100px]">
    <div id="question" class="my-5 mx-10">
        <div class="border border-[#669BBC] rounded-[30px] overflow-hidden">

            <nav id="atributes_cont" class="flex justify-between px-10 bg-[#D0E0EA] rounded-t-lg p-1 flex-wrap">
                <span class="cursor-pointer bg-[var(--lightRed)] px-2 rounded-lg text-white" id="question-code"
                    [routerLink]="['/question', question.code]">
                    {{ question.code }}
                </span>
                <span>{{ question.year }}</span>
                <span>{{ question.difficulty }}</span>
                <span>{{ question.question_type }}</span>
                <span>{{ question.positionName }}</span>
                <span>{{ question.bancaName }}</span>
                <span>{{ question.subjectName }}</span>
                <span>{{ question.topicName }}</span>
                <span ngClass="{{isLastAnswerRight}}" *ngIf="hasAnswered">
                    <i class='bx bx-check'></i> Já Respondida!
                </span>
            </nav>


            <header id="question_text_cont" class="bg-[#FDF0D5] p-5" [innerHTML]="question.question"></header>

            <!-- Formulário para questões de múltipla escolha -->
            <form id="alternatives_cont" class="flex flex-col gap-4 py-6 px-6" *ngIf="question.question_type == 'mult'">
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[0]}">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(0)"></i>
                    <label>
                        <input type="radio" name="alternative" value="A" id="radioA" data="A"
                            [(ngModel)]="selectedAlternative" />
                        <span [innerHTML]="question.aa"></span>
                    </label>
                </div>
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[1]}">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(1)"></i>
                    <label>
                        <input type="radio" name="alternative" value="B" id="radioB" data="B"
                            [(ngModel)]="selectedAlternative" />
                        <span [innerHTML]="question.ab"></span>
                    </label>
                </div>
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[2]}">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(2)"></i>
                    <label>
                        <input type="radio" name="alternative" value="C" id="radioC" data="C"
                            [(ngModel)]="selectedAlternative" />
                        <span [innerHTML]="question.ac"></span>
                    </label>
                </div>
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[3]}">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(3)"></i>
                    <label>
                        <input type="radio" name="alternative" value="D" id="radioD" data="D"
                            [(ngModel)]="selectedAlternative" />
                        <span [innerHTML]="question.ad"></span>
                    </label>
                </div>
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[4]}" *ngIf="question.ae">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(4)"></i>
                    <label>
                        <input type="radio" name="alternative" value="E" id="radioE" data="E"
                            [(ngModel)]="selectedAlternative" />
                        <span [innerHTML]="question.ae"></span>
                    </label>
                </div>
                <div class="{{msg_style}}" *ngIf="showResultMsg">
                    <span>{{ msg }}</span>
                </div>
                <button class="flex text-left bg-[#669BBC] text-white p-2 mt-5 w-fit rounded-xl"
                    (click)="onAnswerSubmit($event, question.code)">
                    Responder
                </button>
            </form>




            <!-- Formulário para questões de verdadeiro/falso -->
            <form id="alternatives_cont_tf" class="flex flex-col gap-4 py-6 px-6"
                *ngIf="question.question_type === 'tf'">
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[0]}">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(0)"></i>
                    <label>
                        <input type="radio" name="alternative" value="1" data="V" [(ngModel)]="selectedAlternative" />
                        Verdadeiro
                    </label>
                </div>
                <div class="alternative" [ngClass]="{'removed': removedAlternatives[1]}">
                    <i class='bx bx-cut hidden' (click)="toggleRemoved(1)"></i>
                    <label>
                        <input type="radio" name="alternative" value="0" data="F" [(ngModel)]="selectedAlternative" />
                        Falso
                    </label>
                </div>
                <div class="{{msg_style}}" *ngIf="showResultMsg">
                    <span>{{ msg }}</span>
                </div>
                <button class="flex text-left bg-[#669BBC] text-white p-2 mt-5 w-fit rounded-xl"
                    (click)="onAnswerSubmit($event, question.code)">
                    Responder
                </button>
            </form>

        </div>

        <div id="tools_cont" class="flex px-5 flex-wrap gap-5">
            <button (click)="toggleLike(question.code)" [ngClass]="{liked: isLiked}">
                <img [src]="isLiked ? '/svg/heart2.svg' : '/svg/heart.svg'" alt="Curtir" />
                Curtir
            </button>
            <button (click)="toggleMoreContainer('Gabarito')" *ngIf="isAnswered">
                <img src="/svg/file-check.svg" alt="Gabarito comentado" />
                Gabarito comentado
            </button>
            <button (click)="toggleMoreContainer('Comments')" *ngIf="isAnswered">
                <img src="/svg/comment.svg" alt="Comentários" />
                Comentários
            </button>
            <button (click)="toggleMoreContainer('Statistics')" *ngIf="isAnswered">
                <img src="/svg/statistics.svg" alt="Estatísticas" />
                Estatísticas
            </button>
            <button (click)="postFeedback(question.code)">
                <img src="/svg/report.svg" alt="Reportar erro" />
                Reportar Erro
            </button>
        </div>
    </div>
    <div id="more-container" class="bg-white my-5 mx-10 border border-red-600 rounded-lg p-4 text-wrap"
        *ngIf="isMoreContainerVisible">
        <app-gabarito *ngIf="activeComponent == 'Gabarito'" [gabarito]="question.prof_comment"
            [related]="question.related_contents" [answer]="question.answer">
        </app-gabarito>
        <app-comments *ngIf="activeComponent == 'Comments'" [questionCode]="question.code"
            [questionID]="question.id"></app-comments>
        <app-statistics *ngIf="activeComponent == 'Statistics'" [questionCode]="question.code"></app-statistics>
    </div>
</div>